import { ChangeDetectionStrategy, Component, Input, computed, inject, input } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { ScrollToService } from '@df/dom/scroll/scroll-to.service';
import { TrustpilotWidgetComponent } from '@df/module-trustpilot/trustpilot-widget.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsContent } from '@icms/core/content';
import { PRODUCT_TRUSTPILOT_WIDGET_CONTAINER_CLASS } from 'projects/app-default/src/app/cms/product-trustpilot-widget/product-trustpilot-widget.component';
import { Product } from '../product.decorator';
import { NProductViewLayout } from '../view/layout/product-view-layout.namespace';

@Component({
    selector: 'product-reviews-summary',
    imports: [TrustpilotWidgetComponent],
    templateUrl: 'product-reviews-summary.html',
    styleUrl: 'product-reviews-summary.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductReviewsSummaryComponent extends UiComponent {
    @Input()
    @ICmsContent({
        watchDepth: 2
    })
    content?: NProductViewLayout.IBlockDataContent;

    readonly product = input.required<Product<IProductDataV3>>();

    protected readonly sku = computed(() => this.product().getTrustpilotSkus());

    private scrollToService = inject(ScrollToService);

    protected onClick(): void {
        this.scrollToService.scrollTo('.' + PRODUCT_TRUSTPILOT_WIDGET_CONTAINER_CLASS);
    }
}
